<script>
    export let action;

    let down = false;

    const onClick = () => {
        down = !down;
        action();
    };
</script>

<div on:click={onClick} class:down>
    <slot />
</div>

<style>
    div {
        cursor: pointer;
        padding: 1px;
        border-radius: 50%;
        padding-top: 0.5em;
        padding-bottom: 0.5em;
    }

    div:hover {
        color: var(--primary-light-color);
        background-color: rgb(235, 236, 240);
    }

    div.down {
        border: 3px solid rgb(0, 82, 204);
    }
</style>
